import { render, staticRenderFns } from "./ModalAddSportCompetition.vue?vue&type=template&id=7315932c&"
import script from "./ModalAddSportCompetition.vue?vue&type=script&lang=js&"
export * from "./ModalAddSportCompetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports